import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import { Dropdown, Modal } from "react-bootstrap";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";

const AstroVideoStreamingPrice = () => {
  const [startTime, setStartTime] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [endTime, setEndTime] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [loading, setloading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [currentPrice, setCurrentPrice] = useState("");
  const [changedPrice, setChangedPrice] = useState("");
  const [status, setStatus] = useState("");
  const [start, setStart] = useState(new Date().toISOString().split("T")[0]);
  const [end, setEnd] = useState("");
  const [videodata, setVideodata] = useState("");
  const [astroid, setAstroid] = useState("");

  const videopricedata = async () => {
    try {
      setloading(true);
      const res = await AddUpdate("VideoStreaming/GetVideoStreamRequest", {
        IsApproved: "0",
        createdTimeFrom: startTime,
        createdTimeTo: endTime,
      });
      if(res){
  const datas = JSON.parse(res?.data?.data);
      const table = datas?.Table;
      setVideodata(table);
      }
      else{
        setVideodata([]);
      }

    
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setloading(false);
    }
  };
  const getsingledata = async (astroid) => {
    try {
      setloading(true);
      const res = await AddUpdate(
        "VideoStreaming/GetSingleVideoStreamRequest",
        {
          Id: astroid,
        },
      );
      const datas = JSON.parse(res?.data?.data);
      const table = datas?.Table;
      setEditValue(table);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    videopricedata();
  }, []);

  const handleSearch = () => {
    const formatDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      const yyyy = date.getFullYear();
      const mm = date.getMonth() + 1;
      const dd = date.getDate();
      return `${yyyy}/${mm}/${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    setStart(formattedStartDate);
    setEnd(formattedEndDate);
    videopricedata(formattedStartDate, formattedEndDate);
  };

  useEffect(() => {
   
    if (EditValue && EditValue.length > 0) {
      setCurrentPrice(EditValue[0]?.currentPricePerMin);
      setChangedPrice(EditValue[0]?.Rate);
    }
  }, [EditValue]);

  const handleEditClick = (row) => {
    getsingledata(row?.VideoStreamId);
    setAstroid(row?.astroid);
    setEditModal(true);
  };
  const UpdatePrice = async (row) => {
    let obj = {
      IsApproved: status?.toUpperCase() === "APPROVED" ? 1 : 0,
      AstroID: EditValue[0]?.AstroId,
      StreamId: EditValue[0]?.VideoStreamId,
    };

    await AddUpdate("VideoStreaming/ApprovedStreamRequest", obj);
    swal("Good job!", `Successfully Updated`, "success");
    videopricedata();
    setEditModal(false);
  };

  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const date = new Date(dateTimeStr);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const columns = [
    {
      name: "Astrologer Name",
      selector: (row) => row.AstroName,
      sortable: true,
    },
    {
      name: "Current Price ",
      selector: (row) => row.currentPricePerMin,
      sortable: true,
    },
    {
      name: "Change Price",
      selector: (row) => row.Rate,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => (row.IsApproved ? "Approved" : "Pending"),
      sortable: true,
    },
    ,
    {
      name: "Date",
      selector: (row) => formatDateTime(row.createdTime),

      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="form-group main_card">
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
          Astrologer Video Striming Price Change
        </h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
          <button
            className="btn btn-primary mt-3"
            style={{ width: "100px", marginLeft: "20px" }}
            onClick={() => handleSearch()}
          >
            Search
          </button>
        </div>
      </div>

      <Modal
        className="modal fade "
        show={editModal}
        onHide={setEditModal}
        backdrop="static"
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">
                  Apporoved or Cancel Model{" "}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal(false)}
                  data-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body p-3">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="form-group">
                    <label className="form-label">Current Price</label>

                    <input
                      type="number"
                      name="comment"
                      value={currentPrice}
                      onChange={(e) => setCurrentPrice(e.target.value)}
                      readOnly
                      placeholder=""
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Changed Price</label>

                    <input
                      type="number"
                      name="comment"
                      value={changedPrice}
                      onChange={(e) => setChangedPrice(e.target.value)}
                      // readOnly
                      placeholder=""
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label style={{ color: "black" }} className="form-label">
                      Status
                    </label>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="approved"
                          name="status"
                          value="APPROVED"
                          style={{ color: "black", width: "15px" }}
                          checked={status === "APPROVED"}
                          onChange={(e) => setStatus(e.target.value)}
                        />
                        <label
                          style={{ color: "black" }}
                          className="form-check-label"
                          htmlFor="APPROVED"
                        >
                          Approved
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="cancel"
                          name="status"
                          value="Cancel"
                          style={{ color: "black", width: "15px" }}
                          checked={status === "Cancel"}
                          onChange={(e) => setStatus(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="Cancel">
                          Cancel
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  style={{ color: "black" }}
                  disabled={changedPrice === "" || status === ""}
                  onClick={() => {
                    UpdatePrice();
                  }}
                  className="btn btn-success"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Update
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setEditModal(false);
                  }}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <div className="col-12 mt-2 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={videodata || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            customStyles={customStyles}
            noDataComponent={"There are no data to display"}
          />
        )}
      </div>
    </div>
  );
};
export default AstroVideoStreamingPrice;
